import React, { useEffect, useState } from "react";
import stylesColor from "../ColorPicker/ColorPicker.module.scss";
import stylesLetter from "./LetterPicker.module.scss";
import { Carousel } from "react-bootstrap";

export default function LetterSwatches({
  letterArray,
  colorSwatchesClass,
  selected,
  onClick,
  chunkSize,
}) {
  var letterArrayFormatted = [];
  for (let i = 0; i < letterArray.length; i += chunkSize) {
    letterArrayFormatted.push(letterArray.slice(i, i + chunkSize));
  }
  const numberOfSlides = letterArrayFormatted.length;
  var slideClass = stylesColor["slide-desktop"];
  if (numberOfSlides == 1) {
    slideClass =
      "ps-2 pe-2 d-flex overflow-auto " + stylesColor["slide-mobile"];
  }

  return (
    <Carousel
      id="#letterCarousel"
      className={`${colorSwatchesClass} ${stylesColor["color-carousel"]}`}
      interval={null}
      wrap={false}
      prevIcon={
        <span
          id="#letterPrev"
          className={`d-none d-md-block position-absolute ${stylesColor["carousel-control-prev-icon"]}`}
        >
          <img src="/right-arrow.svg" />
        </span>
      }
      nextIcon={
        <span
          id="letterNext"
          className={`d-none d-md-block position-absolute ${stylesColor["carousel-control-next-icon"]}`}
        >
          <img src="/right-arrow.svg" />
        </span>
      }
    >
      {letterArrayFormatted.map((letterArrayValue, index) => (
        <Carousel.Item key={index} className={slideClass}>
          {letterArrayValue.map((letter) => (
            <div
              id="#letterOuter"
              key={letter}
              className={`d-block float-start ${stylesColor["outer-circle"]} ${
                letter === selected ? stylesColor["active"] : ""
              } rounded-circle position-relative`}
              onClick={() => onClick(letter)}
            >
              <div
                id="#letterEach"
                className={`${stylesColor["inner-circle"]} rounded-circle position-absolute ${stylesLetter.letter} `}
              >
                {letter}
              </div>
            </div>
          ))}
        </Carousel.Item>
      ))}
    </Carousel>
  );
}
